import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// redux
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import { startChecking, startLoadingUsuarios } from "../store/slices/usuario";
import { obtenerCursos } from "../store/slices/curso";
// routes
import Auth from '../pages/auth';

import PrivateRoute from "./PrivateRoute";

import Inicio from "../pages/inicio";

import Cargando from "../components/Cargando/Cargando";
import AuthRoute from "./AuthRoute";
import Curso from "../pages/curso";

const Router = () => {

  const dispatch = useDispatch<AppDispatch>();

  const { usuario, isLoading } = useSelector((state: RootState) => state.usuario);

  useEffect(() => {
    dispatch(startLoadingUsuarios());
    dispatch(startChecking());
  }, [dispatch]);

  useEffect(() => {
    if (usuario?.uid) {
      console.log('Buscando cursos')
      dispatch(obtenerCursos());
    }
  }, [dispatch, usuario]);

  if (isLoading) {
    return <Cargando />
  }

  return (
    <BrowserRouter>
      <Routes>

        {/* Autenticación */}
        <Route path="/auth" element={
          <AuthRoute isAuthenticated={!!usuario?.uid}>
            <Auth />
          </AuthRoute>
        }
        />

        {/* Inicio */}
        <Route path="/inicio" element={
          <PrivateRoute isAuthenticated={!!usuario?.uid}>
            <Inicio />
          </PrivateRoute>
        }
        />

        {/* Curso */}
        <Route path={'/curso/:sigla/:ruta'} element={
          <PrivateRoute isAuthenticated={!!usuario?.uid}>
            <Curso />
          </PrivateRoute>
        }
        />

        <Route path="/*" element={<Navigate to="/inicio" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router